/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as BankRouteImport } from './routes/bank'
import { Route as ClearancesRouteImport } from './routes/clearances'
import { Route as HomeRouteImport } from './routes/home'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAlertsRouteImport } from './routes/_app/alerts'
import { Route as AppAuditRouteImport } from './routes/_app/audit'
import { Route as AppForecastRouteImport } from './routes/_app/forecast'
import { Route as AppLettersRouteImport } from './routes/_app/letters'
import { Route as AppQueueRouteImport } from './routes/_app/queue'
import { Route as AppReportsRouteImport } from './routes/_app/reports'
import { Route as DevComponentsRouteImport } from './routes/dev.components'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalLettersRouteImport } from './routes/portal/letters'
import { Route as PortalReleaseRouteImport } from './routes/portal/release'
import { Route as PortalSubmitRouteImport } from './routes/portal/submit'
import { Route as VerifyTokenRouteImport } from './routes/verify.$token'
import { Route as AppAdminImportRouteImport } from './routes/_app/admin/import'
import { Route as AppAdminRulesRouteImport } from './routes/_app/admin/rules'
import { Route as AppInstitutionsIndexRouteImport } from './routes/_app/institutions/index'
import { Route as AppInstitutionsInstitutionIdRouteImport } from './routes/_app/institutions/$institutionId'
import { Route as AppInstrumentsIndexRouteImport } from './routes/_app/instruments/index'
import { Route as AppInstrumentsInstrumentIdRouteImport } from './routes/_app/instruments/$instrumentId'
import { Route as AppReleasesIndexRouteImport } from './routes/_app/releases/index'
import { Route as AppReleasesCaseIdRouteImport } from './routes/_app/releases/$caseId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const BankRoute = BankRouteImport.update({
  id: '/bank',
  path: '/bank',
  getParentRoute: () => rootRouteImport,
} as any)
const ClearancesRoute = ClearancesRouteImport.update({
  id: '/clearances',
  path: '/clearances',
  getParentRoute: () => rootRouteImport,
} as any)
const HomeRoute = HomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsRoute = AppAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditRoute = AppAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AppRoute,
} as any)
const AppForecastRoute = AppForecastRouteImport.update({
  id: '/forecast',
  path: '/forecast',
  getParentRoute: () => AppRoute,
} as any)
const AppLettersRoute = AppLettersRouteImport.update({
  id: '/letters',
  path: '/letters',
  getParentRoute: () => AppRoute,
} as any)
const AppQueueRoute = AppQueueRouteImport.update({
  id: '/queue',
  path: '/queue',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsRoute = AppReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AppRoute,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/dev/components',
  path: '/dev/components',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRoute,
} as any)
const PortalLettersRoute = PortalLettersRouteImport.update({
  id: '/letters',
  path: '/letters',
  getParentRoute: () => PortalRoute,
} as any)
const PortalReleaseRoute = PortalReleaseRouteImport.update({
  id: '/release',
  path: '/release',
  getParentRoute: () => PortalRoute,
} as any)
const PortalSubmitRoute = PortalSubmitRouteImport.update({
  id: '/submit',
  path: '/submit',
  getParentRoute: () => PortalRoute,
} as any)
const VerifyTokenRoute = VerifyTokenRouteImport.update({
  id: '/verify/$token',
  path: '/verify/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAdminImportRoute = AppAdminImportRouteImport.update({
  id: '/admin/import',
  path: '/admin/import',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRulesRoute = AppAdminRulesRouteImport.update({
  id: '/admin/rules',
  path: '/admin/rules',
  getParentRoute: () => AppRoute,
} as any)
const AppInstitutionsIndexRoute = AppInstitutionsIndexRouteImport.update({
  id: '/institutions/',
  path: '/institutions/',
  getParentRoute: () => AppRoute,
} as any)
const AppInstitutionsInstitutionIdRoute =
  AppInstitutionsInstitutionIdRouteImport.update({
    id: '/institutions/$institutionId',
    path: '/institutions/$institutionId',
    getParentRoute: () => AppRoute,
  } as any)
const AppInstrumentsIndexRoute = AppInstrumentsIndexRouteImport.update({
  id: '/instruments/',
  path: '/instruments/',
  getParentRoute: () => AppRoute,
} as any)
const AppInstrumentsInstrumentIdRoute =
  AppInstrumentsInstrumentIdRouteImport.update({
    id: '/instruments/$instrumentId',
    path: '/instruments/$instrumentId',
    getParentRoute: () => AppRoute,
  } as any)
const AppReleasesIndexRoute = AppReleasesIndexRouteImport.update({
  id: '/releases/',
  path: '/releases/',
  getParentRoute: () => AppRoute,
} as any)
const AppReleasesCaseIdRoute = AppReleasesCaseIdRouteImport.update({
  id: '/releases/$caseId',
  path: '/releases/$caseId',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/bank': typeof BankRoute
  '/clearances': typeof ClearancesRoute
  '/home': typeof HomeRoute
  '/portal': typeof PortalRouteWithChildren
  '/signin': typeof SigninRoute
  '/alerts': typeof AppAlertsRoute
  '/audit': typeof AppAuditRoute
  '/forecast': typeof AppForecastRoute
  '/letters': typeof AppLettersRoute
  '/queue': typeof AppQueueRoute
  '/reports': typeof AppReportsRoute
  '/dev/components': typeof DevComponentsRoute
  '/portal/letters': typeof PortalLettersRoute
  '/portal/release': typeof PortalReleaseRoute
  '/portal/submit': typeof PortalSubmitRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/portal/': typeof PortalIndexRoute
  '/admin/import': typeof AppAdminImportRoute
  '/admin/rules': typeof AppAdminRulesRoute
  '/institutions/$institutionId': typeof AppInstitutionsInstitutionIdRoute
  '/instruments/$instrumentId': typeof AppInstrumentsInstrumentIdRoute
  '/releases/$caseId': typeof AppReleasesCaseIdRoute
  '/institutions/': typeof AppInstitutionsIndexRoute
  '/instruments/': typeof AppInstrumentsIndexRoute
  '/releases/': typeof AppReleasesIndexRoute
}
export interface FileRoutesByTo {
  '/bank': typeof BankRoute
  '/clearances': typeof ClearancesRoute
  '/home': typeof HomeRoute
  '/signin': typeof SigninRoute
  '/alerts': typeof AppAlertsRoute
  '/audit': typeof AppAuditRoute
  '/forecast': typeof AppForecastRoute
  '/letters': typeof AppLettersRoute
  '/queue': typeof AppQueueRoute
  '/reports': typeof AppReportsRoute
  '/dev/components': typeof DevComponentsRoute
  '/portal/letters': typeof PortalLettersRoute
  '/portal/release': typeof PortalReleaseRoute
  '/portal/submit': typeof PortalSubmitRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/': typeof AppIndexRoute
  '/portal': typeof PortalIndexRoute
  '/admin/import': typeof AppAdminImportRoute
  '/admin/rules': typeof AppAdminRulesRoute
  '/institutions/$institutionId': typeof AppInstitutionsInstitutionIdRoute
  '/instruments/$instrumentId': typeof AppInstrumentsInstrumentIdRoute
  '/releases/$caseId': typeof AppReleasesCaseIdRoute
  '/institutions': typeof AppInstitutionsIndexRoute
  '/instruments': typeof AppInstrumentsIndexRoute
  '/releases': typeof AppReleasesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/bank': typeof BankRoute
  '/clearances': typeof ClearancesRoute
  '/home': typeof HomeRoute
  '/portal': typeof PortalRouteWithChildren
  '/signin': typeof SigninRoute
  '/_app/alerts': typeof AppAlertsRoute
  '/_app/audit': typeof AppAuditRoute
  '/_app/forecast': typeof AppForecastRoute
  '/_app/letters': typeof AppLettersRoute
  '/_app/queue': typeof AppQueueRoute
  '/_app/reports': typeof AppReportsRoute
  '/dev/components': typeof DevComponentsRoute
  '/portal/letters': typeof PortalLettersRoute
  '/portal/release': typeof PortalReleaseRoute
  '/portal/submit': typeof PortalSubmitRoute
  '/verify/$token': typeof VerifyTokenRoute
  '/_app/': typeof AppIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/_app/admin/import': typeof AppAdminImportRoute
  '/_app/admin/rules': typeof AppAdminRulesRoute
  '/_app/institutions/$institutionId': typeof AppInstitutionsInstitutionIdRoute
  '/_app/instruments/$instrumentId': typeof AppInstrumentsInstrumentIdRoute
  '/_app/releases/$caseId': typeof AppReleasesCaseIdRoute
  '/_app/institutions/': typeof AppInstitutionsIndexRoute
  '/_app/instruments/': typeof AppInstrumentsIndexRoute
  '/_app/releases/': typeof AppReleasesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/bank'
    | '/clearances'
    | '/home'
    | '/portal'
    | '/signin'
    | '/alerts'
    | '/audit'
    | '/forecast'
    | '/letters'
    | '/queue'
    | '/reports'
    | '/dev/components'
    | '/portal/letters'
    | '/portal/release'
    | '/portal/submit'
    | '/verify/$token'
    | '/portal/'
    | '/admin/import'
    | '/admin/rules'
    | '/institutions/$institutionId'
    | '/instruments/$instrumentId'
    | '/releases/$caseId'
    | '/institutions/'
    | '/instruments/'
    | '/releases/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/bank'
    | '/clearances'
    | '/home'
    | '/signin'
    | '/alerts'
    | '/audit'
    | '/forecast'
    | '/letters'
    | '/queue'
    | '/reports'
    | '/dev/components'
    | '/portal/letters'
    | '/portal/release'
    | '/portal/submit'
    | '/verify/$token'
    | '/'
    | '/portal'
    | '/admin/import'
    | '/admin/rules'
    | '/institutions/$institutionId'
    | '/instruments/$instrumentId'
    | '/releases/$caseId'
    | '/institutions'
    | '/instruments'
    | '/releases'
  id:
    | '__root__'
    | '/_app'
    | '/bank'
    | '/clearances'
    | '/home'
    | '/portal'
    | '/signin'
    | '/_app/alerts'
    | '/_app/audit'
    | '/_app/forecast'
    | '/_app/letters'
    | '/_app/queue'
    | '/_app/reports'
    | '/dev/components'
    | '/portal/letters'
    | '/portal/release'
    | '/portal/submit'
    | '/verify/$token'
    | '/_app/'
    | '/portal/'
    | '/_app/admin/import'
    | '/_app/admin/rules'
    | '/_app/institutions/$institutionId'
    | '/_app/instruments/$instrumentId'
    | '/_app/releases/$caseId'
    | '/_app/institutions/'
    | '/_app/instruments/'
    | '/_app/releases/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  BankRoute: typeof BankRoute
  ClearancesRoute: typeof ClearancesRoute
  HomeRoute: typeof HomeRoute
  PortalRoute: typeof PortalRouteWithChildren
  SigninRoute: typeof SigninRoute
  DevComponentsRoute: typeof DevComponentsRoute
  VerifyTokenRoute: typeof VerifyTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bank': {
      id: '/bank'
      path: '/bank'
      fullPath: '/bank'
      preLoaderRoute: typeof BankRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/clearances': {
      id: '/clearances'
      path: '/clearances'
      fullPath: '/clearances'
      preLoaderRoute: typeof ClearancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/home': {
      id: '/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof HomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts': {
      id: '/_app/alerts'
      path: '/alerts'
      fullPath: '/alerts'
      preLoaderRoute: typeof AppAlertsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit': {
      id: '/_app/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AppAuditRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/forecast': {
      id: '/_app/forecast'
      path: '/forecast'
      fullPath: '/forecast'
      preLoaderRoute: typeof AppForecastRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/letters': {
      id: '/_app/letters'
      path: '/letters'
      fullPath: '/letters'
      preLoaderRoute: typeof AppLettersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/queue': {
      id: '/_app/queue'
      path: '/queue'
      fullPath: '/queue'
      preLoaderRoute: typeof AppQueueRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports': {
      id: '/_app/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AppReportsRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/components': {
      id: '/dev/components'
      path: '/dev/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/letters': {
      id: '/portal/letters'
      path: '/letters'
      fullPath: '/portal/letters'
      preLoaderRoute: typeof PortalLettersRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/release': {
      id: '/portal/release'
      path: '/release'
      fullPath: '/portal/release'
      preLoaderRoute: typeof PortalReleaseRouteImport
      parentRoute: typeof PortalRoute
    }
    '/portal/submit': {
      id: '/portal/submit'
      path: '/submit'
      fullPath: '/portal/submit'
      preLoaderRoute: typeof PortalSubmitRouteImport
      parentRoute: typeof PortalRoute
    }
    '/verify/$token': {
      id: '/verify/$token'
      path: '/verify/$token'
      fullPath: '/verify/$token'
      preLoaderRoute: typeof VerifyTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/admin/import': {
      id: '/_app/admin/import'
      path: '/admin/import'
      fullPath: '/admin/import'
      preLoaderRoute: typeof AppAdminImportRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin/rules': {
      id: '/_app/admin/rules'
      path: '/admin/rules'
      fullPath: '/admin/rules'
      preLoaderRoute: typeof AppAdminRulesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/institutions/': {
      id: '/_app/institutions/'
      path: '/institutions'
      fullPath: '/institutions/'
      preLoaderRoute: typeof AppInstitutionsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/institutions/$institutionId': {
      id: '/_app/institutions/$institutionId'
      path: '/institutions/$institutionId'
      fullPath: '/institutions/$institutionId'
      preLoaderRoute: typeof AppInstitutionsInstitutionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/instruments/': {
      id: '/_app/instruments/'
      path: '/instruments'
      fullPath: '/instruments/'
      preLoaderRoute: typeof AppInstrumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/instruments/$instrumentId': {
      id: '/_app/instruments/$instrumentId'
      path: '/instruments/$instrumentId'
      fullPath: '/instruments/$instrumentId'
      preLoaderRoute: typeof AppInstrumentsInstrumentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/releases/': {
      id: '/_app/releases/'
      path: '/releases'
      fullPath: '/releases/'
      preLoaderRoute: typeof AppReleasesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/releases/$caseId': {
      id: '/_app/releases/$caseId'
      path: '/releases/$caseId'
      fullPath: '/releases/$caseId'
      preLoaderRoute: typeof AppReleasesCaseIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAlertsRoute: typeof AppAlertsRoute
  AppAuditRoute: typeof AppAuditRoute
  AppForecastRoute: typeof AppForecastRoute
  AppLettersRoute: typeof AppLettersRoute
  AppQueueRoute: typeof AppQueueRoute
  AppReportsRoute: typeof AppReportsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAdminImportRoute: typeof AppAdminImportRoute
  AppAdminRulesRoute: typeof AppAdminRulesRoute
  AppInstitutionsInstitutionIdRoute: typeof AppInstitutionsInstitutionIdRoute
  AppInstrumentsInstrumentIdRoute: typeof AppInstrumentsInstrumentIdRoute
  AppReleasesCaseIdRoute: typeof AppReleasesCaseIdRoute
  AppInstitutionsIndexRoute: typeof AppInstitutionsIndexRoute
  AppInstrumentsIndexRoute: typeof AppInstrumentsIndexRoute
  AppReleasesIndexRoute: typeof AppReleasesIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAlertsRoute: AppAlertsRoute,
  AppAuditRoute: AppAuditRoute,
  AppForecastRoute: AppForecastRoute,
  AppLettersRoute: AppLettersRoute,
  AppQueueRoute: AppQueueRoute,
  AppReportsRoute: AppReportsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAdminImportRoute: AppAdminImportRoute,
  AppAdminRulesRoute: AppAdminRulesRoute,
  AppInstitutionsInstitutionIdRoute: AppInstitutionsInstitutionIdRoute,
  AppInstrumentsInstrumentIdRoute: AppInstrumentsInstrumentIdRoute,
  AppReleasesCaseIdRoute: AppReleasesCaseIdRoute,
  AppInstitutionsIndexRoute: AppInstitutionsIndexRoute,
  AppInstrumentsIndexRoute: AppInstrumentsIndexRoute,
  AppReleasesIndexRoute: AppReleasesIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface PortalRouteChildren {
  PortalLettersRoute: typeof PortalLettersRoute
  PortalReleaseRoute: typeof PortalReleaseRoute
  PortalSubmitRoute: typeof PortalSubmitRoute
  PortalIndexRoute: typeof PortalIndexRoute
}

const PortalRouteChildren: PortalRouteChildren = {
  PortalLettersRoute: PortalLettersRoute,
  PortalReleaseRoute: PortalReleaseRoute,
  PortalSubmitRoute: PortalSubmitRoute,
  PortalIndexRoute: PortalIndexRoute,
}

const PortalRouteWithChildren =
  PortalRoute._addFileChildren(PortalRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  BankRoute: BankRoute,
  ClearancesRoute: ClearancesRoute,
  HomeRoute: HomeRoute,
  PortalRoute: PortalRouteWithChildren,
  SigninRoute: SigninRoute,
  DevComponentsRoute: DevComponentsRoute,
  VerifyTokenRoute: VerifyTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
